export const STATES = [
    "PENDIENTE",
    "EN ESPERA",
    "RECHAZADO",
    "AUTORIZADO"
];

export const ifState = (state) => {
    if(state== "PENDIENTE"){
        return ["EN ESPERA", "AUTORIZADO", "RECHAZADO"];
    }else if(state== "EN ESPERA"){
        return ["PENDIENTE", "AUTORIZADO", "RECHAZADO"];
    }else if(state== "RECHAZADO"){
        return ["PENDIENTE"];
    }else if(state== "AUTORIZADO"){
        return [];
    }
    return [];
}